import React from 'react';
import { withLayout } from 'src/components/Layout';
import {
  getStaticPaths as _getStaticPaths,
  getStaticProps as _getStaticProps,
  StaticArticleDataProps,
} from 'src/data-fetching/fetch-articlesSlug';
import RouterFallback from 'src/components/RouterFallback';
import ArticleDetailsPageContainer from 'src/containers/ArticleDetailsPageContainer';
import withGlobalData from 'src/hocs/with-global-data';
import { SWRConfig } from 'swr';

const ArticleDetailsPage = (props: StaticArticleDataProps) => {
  return (
    <RouterFallback error={'error' in props}>
      <SWRConfig value={{ fallback: props.fallback }}>
        <ArticleDetailsPageContainer slug={props.slug} />
      </SWRConfig>
    </RouterFallback>
  );
};

export const getStaticPaths = _getStaticPaths;
export const getStaticProps = withGlobalData(_getStaticProps, {
  numOfAdverts: 3,
});
export default withLayout(ArticleDetailsPage as any);
